import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { FieldControllerProps } from '@dreryk/react-common';

import { visitTranslationKeys } from '../../../../../../translations';

import { usePatientSearchCreator } from './PatientAutosuggest.hooks';
import { StyledPatientAutosuggest } from './PatientAutosuggest.styled';
import { patientItemRenderer, patientLabelExtractor } from './PatientAutosuggest.utils';

export type PatientValue = PatientSimple | null;
type PatientAutosuggestProps = FieldControllerProps<'patient', PatientValue> & { readonly disabled: boolean };

export const PatientAutosuggest = (props: PatientAutosuggestProps): JSX.Element => {
   return (
      <StyledPatientAutosuggest<PatientSimple>
         searchCreator={usePatientSearchCreator}
         noResultsMessage={visitTranslationKeys.patient.patientNotFound}
         label={visitTranslationKeys.patient.patient}
         keyProperty={'id'}
         itemRenderer={patientItemRenderer}
         labelExtractor={patientLabelExtractor}
         controller={props.register(props.name, {
            required: true,
         })}
         placeholder={visitTranslationKeys.patient.searchPlaceholder}
         minChars={3}
         testId={'patient'}
         disabled={props.disabled}
      />
   );
};
